import { Component, OnInit } from '@angular/core';
import {currencyMask} from '../../../utilities/utils';
import {AirportService} from '../../../airport/services/airport/airport.service';
import {Airport} from '../../../airport/interfaces/Airport';
import {ECerfStatus} from '../../interfaces/ECerfStatus';
import {EntityFilter} from '../../../servicereport/interfaces/serviceReportFilters';
import {
  ReportDialogComponent,
  ReportDialogData
} from '../../../utilities/components/report-dialog/report-dialog.component';
import {MdDialog} from '@angular/material';
import {
  MultiSelectOption,
  MultiSelectOptionValue
} from '../../../utilities/components/multiselect-dropdown/multiselect-dropdown.component';
import {CerfService} from '../../services/cerf/cerf.service';

@Component({
  selector: 'app-cerf-report',
  templateUrl: './cerf-report.component.html',
  styleUrls: ['./cerf-report.component.scss']
})
export class CerfReportComponent implements OnInit {

  currencyMask = { mask: currencyMask };
  airportOptions: Airport[] = [];

  cerfStatusOptions: MultiSelectOption[] = [
    {name: ECerfStatus.DENIED, 'id': ECerfStatus.DENIED},
    {name: ECerfStatus.PENDING_APPROVAL, 'id': ECerfStatus.PENDING_APPROVAL},
    {name: ECerfStatus.FULLY_APPROVED, 'id': ECerfStatus.FULLY_APPROVED}
  ];

  budgetedOptions: MultiSelectOption[] = [{name: 'Budgeted', 'id': '1'}, {name: 'Unbudgeted', 'id': '0'}];

  filters: {
    airports?: number[];
    statuses?: string[];
    budgeted?: string[];
    minAmount?: string;
    maxAmount?: string;
  } = {};


  constructor(public airportService: AirportService, public dialog: MdDialog, private cerfService: CerfService) { }

  async ngOnInit() {
    this.airportOptions = (await this.airportService.getAllAirports()).data
  }

  onAirportsChange(airports: MultiSelectOptionValue[]) {
    this.filters.airports = <number[]>this.getMultiValue(this.airportOptions, airports);
  }

  onStatusesChange(statuses: MultiSelectOptionValue[]) {
    this.filters.statuses = <string[]>this.getMultiValue(this.cerfStatusOptions, statuses);
  }

  onBudgetedChange(budgetedValues: MultiSelectOptionValue[]) {
    this.filters.budgeted = <string[]>this.getMultiValue(this.budgetedOptions, budgetedValues);
  }

  getMultiValue(options: any[], values?: MultiSelectOptionValue[]) {
    if (values === undefined)
      return undefined;
    if (values.length === 0 || values.length === options.length)
      return undefined;
    else
      return values.map(v => v.id);
  }

  onMinAmountChange(value: string) {
    this.filters.minAmount = value ? value : undefined;
  }

  onMaxAmountChange(value: string) {
    this.filters.maxAmount = value ? value : undefined;
  }

  runReport() {
    console.log(this.filters);
    this.dialog.open(ReportDialogComponent, {
      height: '250px',
      width: '600px',
      data: <ReportDialogData>(() => this.cerfService.runReport(this.filters))
    }).afterClosed().subscribe();
  }

}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/cerf/components/cerf-report/cerf-report.component.ts